export default {
  common: {
    price: '{{currency}} {{amount}}',
    dateRange: '{{from}} - {{to}}',
    currencyJpy: 'JPY',
    suggestVisitingTime: 'Suggested visit duration',
    searchIcon: '✦',
    zoomIn: '+',
    zoomOut: '−',
    back: '←'
  },
  home: {
    searchPlaceholder: 'Where would you like to go?',
    scale800m: '15 min walk (800m)',
    scale2km: 'Within 2 metro stops (2km)',
    scale5km: 'Within 5 metro stops (5km)',
    nearbyCount: '{{count}} places',
    listMode: 'List mode',
    mapMode: 'Map mode',
    exploreNearby: 'Explore nearby',
    filterAll: 'All',
    tataGreeting:
      "Hi, I'm tata!\nHere's what's worth seeing around {{city}} today~",
    tataGreetingFallback:
      "Hi, I'm tata!\nLet's discover more fun places together~"
  },
  search: {
    noResults: 'No results',
    youMayLike: 'You may like',
    whereNext: 'Where to next?'
  },
  booking: {
    ticketInfo: 'Ticket info',
    viewTicket: 'View e-ticket',
    plan: 'Plan',
    date: 'Date',
    participants: 'Guests',
    highlights: 'Highlights',
    openingHours: 'Opening hours',
    address: 'Address',
    officialSite: 'Official site',
    goingTo: 'Heading to {{title}}',
    nextStation: 'Your next stop'
  },
  profile: {
    backToMap: 'Back to map',
    my: 'My',
    tickets: 'Tickets',
    favourites: 'Favourites',
    exploreMore: 'Explore more',
    viewMap: 'View map'
  },
  bookmarks: {
    myBookmarks: 'My favourites',
    empty: 'No favourites yet'
  },
  tickets: {
    myTickets: 'My tickets',
    quantity: 'Quantity',
    viewTicket: 'View ticket',
    empty: 'No tickets yet'
  },
  voucher: {
    scanCode: 'Scan the code',
    useEticket: 'Tap to use the e-ticket',
    ticketDetail: 'Ticket details',
    notification: 'For details or manual exchange, tap "Ticket details"',
    orderId: 'Order ID: {{id}}'
  },
  poi: {
    highlights: 'Highlights',
    openingHours: 'Opening hours',
    address: 'Address',
    officialWebsite: 'Official site',
    adultTicket: 'Adult ticket',
    priceFrom: 'From {{price}}',
    buyTicket: 'Buy ticket',
    viewDetails: 'View details',
    freeAdmission: 'Free admission',
    ratingCount: '{{n}} reviews',
    star: '★',
    clock: '🕐',
    nearbyRecommend: 'Nearby picks',
    recentEvents: 'Recent events',
    distanceTo: '{{distance}} from {{name}}',
    aiGenerated: 'AI-generated content',
    goingTo: 'Heading to',
    categories: {
      experience: 'Experience',
      nature: 'Nature',
      attraction: 'Attraction',
      gourmet: 'Gourmet',
      shopping: 'Shopping'
    }
  },
  event: {
    tag: 'Event',
    period: 'Event period',
    duration: 'Visit duration',
    officialWebsite: 'Event website'
  }
};
